import { useLocation } from "react-router-dom";
import PanelShell from "./PanelShell";
import AreaGuard from "../routes/AreaGuard";
import { useAuthContext } from "../context/AuthProvider";
import { can, canEnterPanel } from "../utils/access";

const PAGE_TITLES = {
    '/panel': 'Mi perfil',
    '/panel/apoyos': 'Quién me da tokens',
};

/**
 * Panel de la modelo.
 *
 * Va aparte de /admin a propósito: mezclarlos convertía "panel de
 * administración" en dos cosas distintas según quién mirase.
 */
export default function PanelLayout() {
    const { user } = useAuthContext();
    const { pathname } = useLocation();

    const sections = [
        {
            title: 'Mi cuenta',
            items: [
                can(user, 'edit_own_profile') && { to: '/panel', end: true, icon: 'fa-id-badge', label: 'Mi perfil' },
                can(user, 'view_own_supporters') && { to: '/panel/apoyos', icon: 'fa-hand-holding-dollar', label: 'Quién me da tokens' },
            ],
        },
        {
            title: 'Ir al sitio',
            items: [
                { to: '/live', icon: 'fa-tower-broadcast', label: 'Salas en vivo' },
                { to: '/modelos', icon: 'fa-users', label: 'Catálogo' },
                { to: '/', icon: 'fa-house', label: 'Portada' },
            ],
        },
    ];

    return (
        <AreaGuard allowed={canEnterPanel}>
            <PanelShell sections={sections} title={PAGE_TITLES[pathname] ?? 'Mi panel'} />
        </AreaGuard>
    );
}
